import { LayoutDefinition } from "./LayoutDefinition";
import { LayoutRecord, LayoutAccessibility } from "./LayoutRecord";
import { TEMPORARY_LAYOUT_ID } from "./temporaryLayout";

export function createEmptyLayout(): LayoutRecord {
  const layoutDefinition = new LayoutDefinition();

  return {
    accessibility: LayoutAccessibility.User,
    created: new Date().toISOString(),
    created_by: "",
    layout_definition: layoutDefinition.state,
    layout_id: TEMPORARY_LAYOUT_ID,
    modified: new Date().toISOString(),
    modified_by: "",
    name: "Untitled layout",
    org_id: "",
    schema_version: layoutDefinition.schemaVersion,
    tags: [],
  };
}
